import { createExternalStore, Storage } from '@iheartjane/utils';
import { useSyncExternalStore } from 'react';

/** Curbside and pickup share the wire mode `'pickup'`; this tells them apart. */
type BagPickupMode = 'pickup' | 'curbside';

// The key the old cart slice wrote; renaming it drops shoppers' saved choice.
const BAG_PICKUP_MODE_KEY = 'bagPickupMode';

const { notify, subscribe } = createExternalStore();

export const getBagPickupMode = (): BagPickupMode =>
  Storage.get(BAG_PICKUP_MODE_KEY) === 'curbside' ? 'curbside' : 'pickup';

export const setBagPickupMode = (mode: BagPickupMode) => {
  Storage.set(BAG_PICKUP_MODE_KEY, mode);
  notify();
};

/** Not tied to cart clears: flag-on, the boot `getCart()` clears an empty cart. */
export const resetBagPickupMode = () => {
  Storage.remove(BAG_PICKUP_MODE_KEY);
  notify();
};

export const useBagPickupMode = () =>
  useSyncExternalStore(subscribe, getBagPickupMode, () => 'pickup' as const);
